import type { ReactNode } from "react";
// import { Pin, ThumbsUp } from "lucide-react";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

type WidgetCardProps = {
  title: string;
  children: ReactNode;
  footerContent?: ReactNode;
  className?: string;
};
const WidgetCard = ({
  title,
  children,
  footerContent,
  className,
}: WidgetCardProps) => {
  return (
    <Card
      className={`flex h-full flex-col border-0 bg-white drop-shadow-md ${className} overflow-hidden`}
    >
      <CardHeader className="flex-row justify-between border-b-2">
        <CardTitle as="h2" className="text-md">
          {title}
        </CardTitle>
        <div className="flex items-center gap-2">
          {/* <Pin /> */}
          {/* <ThumbsUp /> */}
        </div>
      </CardHeader>

      <CardContent className="flex-1 overflow-y-auto p-3">
        {children}
      </CardContent>

      <CardFooter
        className={`bottom-0 mt-auto w-full justify-center border-t-2 bg-white pt-3 ${!footerContent ? "hidden" : "block"}`}
      >
        {footerContent}
      </CardFooter>
    </Card>
  );
};

export default WidgetCard;
